var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7563 12.6188L12.6 11.775L9.61875 8.775V5.00625H8.49375V9.225L11.7563 12.6188ZM9 16.5C7.975 16.5 7.00625 16.3031 6.09375 15.9094C5.18125 15.5156 4.38438 14.9781 3.70312 14.2969C3.02188 13.6156 2.48437 12.8188 2.09062 11.9062C1.69687 10.9937 1.5 10.025 1.5 9C1.5 7.975 1.69687 7.00625 2.09062 6.09375C2.48437 5.18125 3.02188 4.38438 3.70312 3.70312C4.38438 3.02188 5.18125 2.48437 6.09375 2.09062C7.00625 1.69687 7.975 1.5 9 1.5C10.025 1.5 10.9937 1.69687 11.9062 2.09062C12.8188 2.48437 13.6156 3.02188 14.2969 3.70312C14.9781 4.38438 15.5156 5.18125 15.9094 6.09375C16.3031 7.00625 16.5 7.975 16.5 9C16.5 10.025 16.3031 10.9937 15.9094 11.9062C15.5156 12.8188 14.9781 13.6156 14.2969 14.2969C13.6156 14.9781 12.8188 15.5156 11.9062 15.9094C10.9937 16.3031 10.025 16.5 9 16.5ZM9 15.375C10.75 15.375 12.25 14.75 13.5 13.5C14.75 12.25 15.375 10.75 15.375 9C15.375 7.25 14.75 5.75 13.5 4.5C12.25 3.25 10.75 2.625 9 2.625C7.25 2.625 5.75 3.25 4.5 4.5C3.25 5.75 2.625 7.25 2.625 9C2.625 10.75 3.25 12.25 4.5 13.5C5.75 14.75 7.25 15.375 9 15.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4c19c204ec542c727426dbfeb2a0dee1.svg";
export { ForwardRef as ReactComponent };